import { useTranslation } from 'react-i18next';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { useViewModeAndDate } from '../hooks/use-view-mode-and-date';
import { ViewMode } from '../types/time-tracking';

export function ViewTabs() {
  const { t } = useTranslation('authenticated.timeTracking');
  const { viewMode, setViewMode } = useViewModeAndDate();

  return (
    <Tabs value={viewMode} onValueChange={value => setViewMode(value as ViewMode)}>
      <TabsList>
        <TabsTrigger value={ViewMode.Day}>{t('viewTabs.day')}</TabsTrigger>
        <TabsTrigger value={ViewMode.Week}>{t('viewTabs.week')}</TabsTrigger>
        <TabsTrigger value={ViewMode.Month}>{t('viewTabs.month')}</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
